'use strict';

import analytics from '../utils/analytics.js';
import cookie from '../storage/cookie.js';
import user from '../profile/user.js';

const classNames = {
	motorwayWidget: 'motorway-widget',
	submitButton: 'submit',
	vrmInput: 'vrm__input',
	vrmInvalidMessage: 'vrm__invalid-message'
};

const bemModifiers = {
	invalid: 'invalid'
};

const cssProperties = {
	visibility: 'visibility'
};

const validVrmRegex = '[A-Z]{2}[0-9]{2}[A-Z]{3}|[A-Z][0-9]{1,3}[A-Z]{3}|[A-Z]{3}[0-9]{1,3}[A-Z]|[0-9]{1,4}[A-Z]{1,2}|[0-9]{1,3}[A-Z]{1,3}|[A-Z]{1,2}[0-9]{1,4}|[A-Z]{1,3}[0-9]{1,3}|[A-Z]{1,3}[0-9]{1,4}';

let widgetCssClass;

function validateVrm(vrm) {
	return RegExp(validVrmRegex).test(vrm);
}

function initVrmInput() {
	if (!user.getOwnedVehicleType('car')) {
		return;
	}

	const vrm = cookie.getCookie('stored-vrm');

	if (vrm) {
		const $vrmInput = $.findByBem(widgetCssClass, classNames.vrmInput);
		$vrmInput.val(vrm.toUpperCase());
	}
}

function initValidation() {
	const $vrmInput = $.findByBem(widgetCssClass, classNames.vrmInput);

	$vrmInput.on('input', function () {
		$vrmInput.val($vrmInput.val().toUpperCase());
		$vrmInput.removeBemClass(widgetCssClass, classNames.vrmInput, bemModifiers.invalid);
		$.findByBem(widgetCssClass, classNames.vrmInvalidMessage).css(cssProperties.visibility, 'hidden');
	});

	$vrmInput.on('blur', function () {
		$vrmInput.val($vrmInput.val().replace(/ /g, ''));
		const isValidVrm = validateVrm($vrmInput.val());

		if (!isValidVrm) {
			$vrmInput.addBemClass(widgetCssClass, classNames.vrmInput, bemModifiers.invalid);
			$.findByBem(widgetCssClass, classNames.vrmInvalidMessage).css(cssProperties.visibility, 'visible');
		}
	});
}

function initSubmitButton() {
	const $submitButton = $.findByBem(widgetCssClass, classNames.submitButton);

	$submitButton.on('click', function () {
		const vrm = $.findByBem(widgetCssClass, classNames.vrmInput).val();
		const validVrm = validateVrm(vrm);

		if (!validVrm) {
			return;
		}

		const campaignName = $.findByBem(widgetCssClass).data('motorway-campaign');
		const isVanWidget = $.findByBem(widgetCssClass).data('is-van-widget');

		const queryParams = [
			{name: 'utm_source', value: 'parkers'},
			{name: 'utm_medium', value: 'affiliate'},
			{name: 'utm_campaign', value: campaignName},
			{name: 'vrm', value: vrm}
		];

		analytics.trackEvent('Motorway', 'Compare Offers');

		const redirectUrl = isVanWidget
			? 'https://motorway.co.uk/sell-my-van?' + $.param(queryParams)
			: 'https://motorway.co.uk/?' + $.param(queryParams);

		window.open(redirectUrl, '_blank');
	});
}

export default {
	init: function (bemBlockOverride) {
		widgetCssClass = bemBlockOverride || classNames.motorwayWidget;

		initVrmInput();
		initValidation();
		initSubmitButton();
	}
};
